import type { ApiWriteTourDuplicate } from '#api/model/types.ts';
import { reportErrorToSentry } from '#configuration/setup/sentry.ts';

export const assertValidDuplicateTourPayload = (payload: ApiWriteTourDuplicate) => {
    try {
        const tempIds = new Set<string>();
        for (const order of payload.orders) {
            if (order.temp_id.trim().length === 0) {
                throw new Error('Duplicate order temp_id must not be blank.');
            }

            if (tempIds.has(order.temp_id)) {
                throw new Error(`Duplicate order temp_id must be unique: ${order.temp_id}`);
            }

            tempIds.add(order.temp_id);
        }

        for (const stop of payload.tour.stops) {
            if (!stop.order_id || !tempIds.has(stop.order_id)) {
                throw new Error(`Duplicate tour stop references unknown temp_id: ${stop.order_id}`);
            }
        }
    } catch (error) {
        reportErrorToSentry(error);
        throw error;
    }
};
